export default __webpack_public_path__ + "static/media/repair.a342d139.png";